import React from 'react';
import ContainerImg from '../../Pages/images/latest/container 2.png';
import DollarImg from '../../Pages/images/latest/$.png';
import LogoImg from '../../Pages/images/latest/logo HKAU.png';
import './YourContainer.css';
import { Link } from 'react-router-dom';

const YourContainer = () => {
    return (
        <div className="your-container-section">
            <div className="your-container-main">
                {/* Left Content */}
                <div className="your-container-content-left">
                    <h2 className="your-container-title">
                        <span style={{ lineHeight: "1.7" }}>Your Container.</span><br />
                        <span style={{ lineHeight: "1" }}>    Our Network. Your<br />
                            Earnings.</span>
                    </h2>
                    <p className="your-container-subtitle">
                        Join hands with Brooks Container and turn your container into a consistent source of income.
                    </p>
                    <button className="partner-button">
                        <Link to="/About">
                            PARTNER WITH US
                        </Link>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="partner-arrow">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </button>
                </div>

                {/* Right Flow Diagram */}
                <div className="your-container-flow-right">
                    <div className="flow-step-container">
                        <div className="flow-step">
                            <div className="flow-circle">
                                <img src={ContainerImg} alt="Container" className="flow-icon-img container-img" />
                            </div>
                            <span className="flow-header">YOU</span>
                            <span className="flow-desc">Own a Container</span>
                        </div>

                        <div className="flow-arrow">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </div>

                        <div className="flow-step">
                            <div className="flow-circle logo-circle">
                                <img src={LogoImg} alt="HK AU" className="flow-icon-img logo-img" />
                            </div>
                            <span className="flow-desc lease-desc">We Lease It</span>
                        </div>

                        <div className="flow-arrow">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </div>

                        <div className="flow-step">
                            <div className="flow-circle">
                                <img src={DollarImg} alt="Earnings" className="flow-icon-img dollar-img" />
                            </div>
                            <span className="flow-header">YOU</span>
                            <span className="flow-desc">Earn Monthly Returns</span>
                        </div>
                    </div>

                    <div className="flow-tagline-container">
                        <div className="flow-tagline">TRANSPARENT. SIMPLE. PROFITABLE.</div>
                        <div className="flow-tagline-line"></div>
                    </div>
                </div>
            </div>

            {/* Tan Bottom Footer Bar */}
            <div className="your-container-footer-bar">
                <div className="footer-bar-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                    <span className="footer-text">Global Trade Networks</span>
                </div>
                <div className="footer-bar-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        <polyline points="9 11 11 13 15 9"></polyline>
                    </svg>
                    <span className="footer-text">Trusted Partner</span>
                </div>
                <div className="footer-bar-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="footer-icon">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    <span className="footer-text">Long-Term Relationships</span>
                </div>
            </div>
        </div>
    );
};

export default YourContainer;